<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            use-input
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:option="scope"
            >
                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section side class="q-mr-none" dense v-if="scope.opt.categories && scope.opt.categories.length">
                        <q-icon name="bookmark" size="16px" :style="'color: ' + scope.opt.categories[0].color" />
                    </q-item-section>
                    <q-item-section dense>
                        <q-item-label v-html="scope.opt.label" />
                    </q-item-section>
                </q-item>
            </template>

            <template v-slot:selected v-if="showMax && multiple && $attrs && $attrs.value && $attrs.value.length > parseInt(showMax)">
                <span>{{ $attrs.value.length }} éléments sélectionnés</span>
            </template>

            <template v-slot:selected-item="scope" v-else>
                <span v-if="scope.index > 0" class="q-mr-xs">, </span>
                <span>
                    <q-icon name="bookmark" size="14px" :style="'color: ' + scope.opt.categories[0].color" v-if="scope.opt.categories && scope.opt.categories.length" />
                    {{ scope.opt.label }}
                </span>
            </template>

        </q-select>
    </div>
</template>

<script>
    import { COMPANIES, COMPANIESSEARCH/*, CONTACTS, LOCATIONS*/ } from '@/graphql/company/queries'
    import QSelect from 'quasar'

    export default {
        name: 'CompaniesInput',
        extends: QSelect,
        props: {
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            showMax: {
                type: [Boolean, Number, String],
                default: false
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            }
        },
        data(){
            return {
                searchTO: {}
            }
        },
        computed: {
            menuItems() {
                if(this.$apollo.queries.companies && !this.$apollo.queries.companies.loading) return this.companies.data
                return new Array();
            }
        },
        methods: {
            search(searchText, updatefn){
                clearTimeout(this.searchTO);
                if(searchText && searchText!=""){
                    this.searchTO=setTimeout(function(){
                        if(this.$apollo.queries.companiesSearch){
                            delete this.$apollo.queries.companiesSearch
                        }
                        this.$apollo.addSmartQuery('companiesSearch', {
                            query: COMPANIESSEARCH,
                            fetchPolicy: 'cache-first',
                            error(error){
                                if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                            },
                            variables: {
                                searchText: searchText.trim().split(" ").join("* ")+"*",
                            },
                            manual: true,
                            result ({ data }) {
                                this.companies = Object.assign({}, data.companiesSearch);
                                updatefn();
                            },
                        })
                    }.bind(this), 200)
                }else{
                    this.$apollo.queries.companies.refresh()
                    updatefn();
                }
            }
        },
        apollo: {
            companies: {
                query: COMPANIES,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(companies) {
                    companies=companies.companies;

                    setTimeout(function(){
                        this.$refs.myInput.refresh();
                    }.bind(this), 200)
                    
                    return companies;
                },
                variables() {
                    if(this.variables) return {...this.variables}
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .companies {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }
</style>